import Form from "@/shared/form/form";

export function useErrorWatcher({ name }: { name: string | string[] }) {
  const form = Form.useFormInstance();

  Form.useWatch(name, form);

  const errors = form
    .getFieldsError()
    .filter((field) => {
      const fieldNameArr = Array.isArray(field.name)
        ? field.name
        : [field.name];

      if (Array.isArray(name)) {
        return name.every((part, index) => fieldNameArr[index] === part);
      } else {
        return fieldNameArr.includes(name);
      }
    })
    .reduce((result, field) => [...result, ...field.errors], [] as string[]);

  return {
    errors,
  };
}
